<template>
  <div class="menuBody" style="margin-left:25px;">
    <IconManagementDialog @Visibl="Visibl" ref="IconManagementDialog"/>
    <div class="menuTool" style="width:100%;">
      <el-card class="box-card">
        <el-row :gutter="10">
          <div
              style="width:100%;height:30px;margin-top:10px;border-bottom:1px solid rgba(234, 237, 241, 1);margin-bottom:15px">
            Icon列表
            <div style="float:right;margin-right:10px;margin-top:-10px">
              <el-button type="primary" size="small" plain style="background: #38A38A;color:#fff;border-radius:9px;"
                        v-Jurisdiction="'to:web:file:iconAdd'" @click="PropertyAdd()">添加图标
              </el-button>
            </div>
          </div>
          <el-col :span="3" v-for="item in tableData" :key="item.id">
            <el-card :body-style="{ padding: '0px' }">
              <div class="iconPosition">
                <img :alt="item.iconName" :src="item.iconHref">
              </div>
              <div style="padding: 14px;">
                <span class="iconNamePosition" :title="item.iconName">{{ item.iconName }}</span>
                <div class="bottom clearfix">
                  <el-button type="text" @click="delMenu(item)" v-Jurisdiction="'to:web:file:iconDel'"  class="button" style="font-size:14px;color:red;">删除
                  </el-button>
                </div>
              </div>
            </el-card>
          </el-col>

        </el-row>
      </el-card>
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30, 40]"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          style="float:right;margin-top:25px">
      </el-pagination>
    </div>
  </div>
</template>
<script>
import IconManagementDialog from "./IconManagementDialog";

export default {
  name: "IconManagement",
  components: {IconManagementDialog},
  data() {
    return {
      loading: false,
      total: 0,//默认数据总数
      pagesize: 10,//每页的数据条数
      currentPage: 1,//默认开始页面
      tableData: [],
      currentDate: new Date(),
    }
  },
  methods: {
    ShareList() {
      let PageSize = {
        "page": this.currentPage, // 当前页
        "size": this.pagesize,  // 每页大小
      }
      this.$http.post(this.$requestUrl.ICON_POST_LIST, PageSize).then((res) => {
        let data = res.data;
        if (200 === data.code) {
          this.total = data.data.total
          this.tableData = data.data.records;
          this.loading = false
        } else {
          this.$message.error(result.msg)
          this.loading = false
        }
      }).catch(() => {
        this.$message.error(this.$errorMessage.SEVER_ERROR)
      })
    },
    handleSizeChange(val) {
      this.pagesize = val
      this.ShareList()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.ShareList()
    },
    PropertyAdd() {        // 添加
      this.$refs.IconManagementDialog.title = "添加图标";
      this.$refs.IconManagementDialog.dialogVisibl = true;
    },
    editMenu(row) {        // 修改
      this.$refs.IconManagementDialog.title = "修改图标";
      this.$refs.IconManagementDialog.dialogVisibl = true;
    },
    delMenu(row) {        // 删除
      let id = row.id
      this.$http.delete(this.$requestUrl.ICON_DEL_FILE, id).then((res) => {
        let data = res.data
        if (data.code == 200) {
          console.log(res)
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
        } else {
          this.$message({
            type: 'warning',
            message: '删除失败!'
          });
          this.$message.error(data.msg)
        }
      }).catch(() => {
        this.$message.error(this.$errorMessage.SEVER_ERROR)
      })
    },
    Visibl(data) {
      if (data == false) {
        this.ShareList()
      }
    }
  },
  mounted() {
    this.ShareList()
  }
}
</script>

<style lang="scss">
.menuBody {
  width: 100%;

  .menuTool {
    .el-card {
      .el-card__body {
        padding: 10px 20px;
      }
    }

    margin-bottom: 10px;
  }

  .el-table {
    td {
      padding: 5px;
    }

    th {
      padding: 5px;
    }

    .success-row {
      background: #f0f9eb;

    }
  }

}

.time {
  font-size: 13px;
  color: #999;
}

.bottom {
  margin-top: 13px;
  line-height: 12px;
}

.button {
  padding: 0;
  float: right;
}

.image {
  width: 100%;
  display: block;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both;
}

.iconPosition {
  background: #C0C4CC;
  padding: 14px 0 14px 0;
  display: flex;
  justify-content: center;
  align-content: center;

  img {
    width: 58px;
  }
}

.iconNamePosition {
  font-size:14px;
  width: 95px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
}
</style>